import { createContext } from 'react';

const STORAGE_KEY = 'dink_admin.frontDeskView';

export interface FrontDeskContextValue {
  /** True while the console is restricted to Front Desk (Operations-only) view. */
  frontDeskView: boolean;
  /** Enter Front Desk view (no re-auth) and persist the flag. */
  enterFrontDeskView: () => void;
  /** Exit Front Desk view (after a successful password check) and clear the flag. */
  exitFrontDeskView: () => void;
}

export const FrontDeskContext = createContext<FrontDeskContextValue | null>(null);

/** Read the persisted Front Desk flag from sessionStorage (defaults off). */
export function readFrontDeskView(): boolean {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function writeFrontDeskView(value: boolean): void {
  try {
    if (value) sessionStorage.setItem(STORAGE_KEY, 'true');
    else sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore quota / disabled storage - the in-memory flag still governs the UI */
  }
}
